import { z } from "zod";

const statusSchema = z.union([
  z.literal("Enabled"),
  z.literal("Disabled"),
  z.literal("Unknown"),
]);
const productTypeSchema = z.union([
  z.literal("Default"),
  z.literal("Optional"),
]);

const productSettingTypeSchema = z.union([
  z.literal("TextInput"),
  z.literal("TextArea"),
  z.literal("MaskedTextInput"),
  z.literal("Switch"),
  z.literal("Checkbox"),
  z.literal("DateInput"),
]);

export const productSettingSchema = z.object({
  id: z.string().uuid(),
  key: z.string(),
  name: z.string(),
  order: z.number(),
  dataType: productSettingTypeSchema,
  mandatory: z.boolean(),
  defaultValue: z.union([z.string(), z.boolean()]).nullable(),
  value: z.union([z.string(), z.boolean()]).nullable().optional(),
  description: z.string(),
  clientVisible: z.boolean(),
});

export const productSchema = z.object({
  productId: z.string().uuid(),
  name: z.string(),
  status: statusSchema,
  type: productTypeSchema,
  isDefault: z.boolean(),
  key: z.string(),
  hasSettings: z.boolean().optional().default(true),
});

export const productSettingsSchema = z.object({}).passthrough();

export const productsSchema = z.array(productSchema);
export type Product = z.infer<typeof productSchema>;
export type ProductStatus = z.infer<typeof statusSchema>;
export type ProductSetting = z.infer<typeof productSettingSchema>;
export type ProductSettings = z.infer<typeof productSettingsSchema>;
